import { ApprovalStatus } from "../enums/approval-statuses";

export class OrderApprovalStatusesLookup {

    static getLookup() {
        return [
            { label: 'Covered', id: 1, class: 'fas fa-circle fa-sm palette-Green-500 text' },
            { label: 'Not Covered', id: 0, class: 'fas fa-circle fa-sm palette-Red text' },
            { label: 'Excluded', id: -1, class: 'fas fa-circle fa-sm palette-Orange-500 text' },
        ]
    }

    static getValueLookup() {
        return [
            { label: 'Pending', value: ApprovalStatus.Pending },
            { label: 'Approved', value: ApprovalStatus.Approved },
            { label: 'Rejected', value: ApprovalStatus.Rejected },
            { label: 'Canceled', value: ApprovalStatus.Canceled },
            { label: 'Referred', value: ApprovalStatus.Referred },
            { label: 'Approval Request', value: ApprovalStatus.ApprovalRequest },
            { label: 'Further Details', value: ApprovalStatus.FurtherDetails },
        ]
    }

    static getClassById(id) {
        const lookup = this.getLookup().find(f => f.id === id)?.class;
        return lookup;
    }

    static getById(id) {
        const lookup = this.getValueLookup().find(f => f.value === id)?.label;
        return lookup;
    }
}
